<p class="card-timeline__title" *ngIf="title">{{ title }}</p>

<ol class="card-timeline">
  <li class="card-timeline__event" *ngFor="let ev of items">
    <div class="card-timeline__rail" aria-hidden="true">
      <span class="card-timeline__dot" [ngClass]="dotClass(ev.accent)"></span>
    </div>
    <div class="card-timeline__body">
      <div class="card-timeline__head">
        <span class="card-timeline__label">{{ ev.label }}</span>
        <span class="card-timeline__when">{{ ev.when }}</span>
      </div>
      <p class="card-timeline__detail" *ngIf="ev.detail">{{ ev.detail }}</p>
    </div>
  </li>
</ol>
